<nz-modal
  [nzVisible]="true"
  nzTitle="Send Email"
  [nzWidth]="'70vw'"
  [nzWrapClassName]="showPreview ? 'email-transaction-modal' : 'report-transaction-modal'"
  [nzMaskClosable]="false"
  [nzFooter]="footer"
  (nzOnCancel)="handleCancel()">
  <ng-container *nzModalContent>
    <div nz-row>
      <div nz-col [nzMd]="showPreview ? 10 : 24" [nzSm]="24">
        <form [formGroup]="emailForm" class="sender-form" nz-form>
          <div class="sender-info">
            <div class="info-block">
              <!-- Recipient Name (Readonly) -->
              <div class="block">
                <div class="title">Name:</div>
                <input
                  nz-input
                  type="text"
                  formControlName="receipientName"
                  readonly />
              </div>

              <!-- Recipient Email (Readonly) with BCC Button -->
              <div class="block">
                <div class="title">Send To:</div>
                <div class="input-container">
                  <input
                    class="email-template-required-field"
                    nz-input
                    type="email"
                    formControlName="receipientEmail"
                    readonly
                    [nzStatus]="hasInvalidEmail('receipientEmail') ? 'error' : ''" />
                  <button type="button"
                    nz-button
                    nzType="primary"
                    (click)="toggleBccField()"
                    class="toggle-bcc-button custom-blue-button">
                    BCC
                  </button>
                </div>
                <small class="text-red" *ngIf="hasInvalidEmail('receipientEmail')">
                  Recipient Email is required
                </small>
              </div>

              <!-- CC Field -->
              <div class="block">
                <div class="title ccList">CC:</div>
                <nz-select
                  nzMode="tags"
                  nzPlaceHolder="Select CC emails or add new ones..."
                  formControlName="ccList"
                  [disabled]="readonly()"
                  style="width: 100%">
                  <nz-option-group nzLabel="Primary Email">
                    <nz-option
                      *ngIf="data.primaryEmail && shouldShowPrimaryEmail()"
                      [nzValue]="data.primaryEmail"
                      [nzLabel]="data.primaryEmail"
                      [nzDisabled]="isEmailDisabled(data.primaryEmail, 'ccList')">
                    </nz-option>
                  </nz-option-group>
                  <nz-option-group nzLabel="Secondary Email">
                    <nz-option
                      *ngFor="let email of data.ccOptions"
                      [nzLabel]="email"
                      [nzValue]="email"
                      [nzDisabled]="isEmailDisabled(email, 'ccList')">
                    </nz-option>
                  </nz-option-group>
                </nz-select>
              </div>

              <!-- BCC Field (Conditional) -->
              @if (isBccVisible) {
                <div class="block">
                  <div class="title">BCC:</div>
                  <nz-select
                    nzMode="tags"
                    nzPlaceHolder="Select BCC emails or add new ones..."
                    formControlName="bccList"
                    [disabled]="readonly()"
                    style="width: 100%">
                    <nz-option-group nzLabel="Primary Email">
                      <nz-option
                        *ngIf="data.primaryEmail && shouldShowPrimaryEmail()"
                        [nzValue]="data.primaryEmail"
                        [nzLabel]="data.primaryEmail"
                        [nzDisabled]="isEmailDisabled(data.primaryEmail, 'bccList')">
                      </nz-option>
                    </nz-option-group>
                    <nz-option-group nzLabel="Secondary Email">
                      <nz-option
                        *ngFor="let email of data.ccOptions"
                        [nzLabel]="email"
                        [nzValue]="email"
                        [nzDisabled]="isEmailDisabled(email, 'bccList')">
                      </nz-option>
                    </nz-option-group>
                  </nz-select>
                  @if (hasInvalidEmail('bccList')) {
                    <small class="text-red">
                      Invalid Email Format
                    </small>
                  }
                </div>
              }


              <!-- Subject -->
              <div class="block">
                <div class="title">Subject:</div>
                <input
                  class="email-template-required-field"
                  [readonly]="readonly()"
                  nz-input
                  type="text"
                  formControlName="subject"
                  [nzStatus]="hasInvalidEmail('subject') ? 'error' : ''" />
                <small class="text-red" *ngIf="hasInvalidEmail('subject')">
                  Email Subject is required
                </small>
              </div>

              <!-- Message -->
              <div class="block">
                <div class="title">Message:</div>
                <textarea
                  [readOnly]="readonly()"
                  nz-input
                  rows="8"
                  style="resize: none;"
                  formControlName="message">
                </textarea>
                <div class="small-remark">
                  Attachment Link will be generated upon submission. Please ensure that the [link] tag stays in the
                  content of the message.
                </div>
              </div>
            </div>

            <!-- Action Buttons -->

            @if (!readonly()) {
              <div class="button-block">
                <div class="custom-button-container">
                  <button type="button" nz-button nzType="default" (click)="handleCancel()">
                    Cancel
                  </button>
                  <button type="button"
                    nz-button
                    nzType="primary"
                    (click)="handleSubmit()"
                    [nzLoading]="loading">
                    Send
                  </button>
                </div>
              </div>
            }
          </div>
        </form>
      </div>

      <!-- Preview Section -->
      <div nz-col [nzMd]="14" [nzSm]="24" *ngIf="showPreview">
        <div class="email-preview" id="email-preview">
          <div [innerHTML]="emailPreview" style="margin-bottom: 20px;" class="hidden"></div>

          <!-- Header -->
          <div style="display: flex; width: 100%; padding-top: 25px; padding-bottom: 10px;">
            <div style="display: flex; margin: 0 auto;">
              <!-- Company Image -->
              <div style="margin-right: 10px;">
                <img [src]="companyLogo" style="width: auto;height: 40px;">
              </div>

              <div style="line-height: 16px; margin-top: 3px;">
                <div>
                  <span style="font-weight: bold; color: #08306B; font-size: 19px;">{{ data.companyName }}</span>
                  <span style="font-size: 12px; margin-left: 5px;"><i>({{ data.regNo }})</i></span>
                </div>
                <div>
                  <span style="font-size: 12px;">{{ data.phoneNo }}</span>
                  <span style="font-size: 12px; margin-left: 10px;">{{ data.email }}</span>
                </div>
              </div>
            </div>
          </div>
          <hr>

          <div class="preview-detail-container" style="padding-left: 20px; padding-right: 40px;">
            <!-- Item Header-->
            <table style="width: 100%;">
              <tr>
                <td style="vertical-align: top;">
                  <div>
                    <div style="line-height: 18px; margin-bottom: 10px;">
                      <div style="font-weight: 500; font-size: 15px;">{{ data.recipientBillTargetLabel }}</div>
                      <div>{{ data.receipientName }}</div>
                    </div>
                    <div style="line-height: 18px; margin-bottom: 10px;">
                      <div style="font-weight: 500; font-size: 15px;">Date</div>
                      <div>{{ data.docDate }}</div>
                    </div>
                  </div>
                </td>
                <td align="right">
                  <div>
                    <div style="line-height: 18px; margin-bottom: 10px;">
                      <div style="font-weight: 500; font-size: 15px;">{{ data.transactionType }}</div>
                      <div>{{ data.docCode }}</div>
                    </div>
                    <div *ngIf="data.dueDate" style="line-height: 18px; margin-bottom: 10px;">
                      <div style="font-weight: 500; font-size: 15px;">Due Date</div>
                      <div>{{ data.dueDate }}</div>
                    </div>
                    <div *ngIf="data.term" style="line-height: 18px; margin-bottom: 10px;">
                      <div style="font-weight: 500; font-size: 15px;">Term</div>
                      <div>{{ data.term }}</div>
                    </div>
                  </div>
                </td>
              </tr>
            </table>
            <!-- END:Item Header -->

            <!-- Item Details -->
            <div style="padding: 0 30px; margin: 25px 0;">
              <!-- Default Invoice Template (0) -->
              <ng-container *ngIf="previewTemplateKey === templateKeys.defaultInvoice">
                <table border="1" cellpadding="8" style="width: 100%; border-collapse: collapse;">
                  <tr style="text-align: center;">
                    <th style="padding: 5px; border: 1px solid #000000;">#</th>
                    <th style="padding: 5px; border: 1px solid #000000;">Product/Description</th>
                    <th style="padding: 5px; border: 1px solid #000000;">Amount</th>
                    <th style="padding: 5px; border: 1px solid #000000;">Qty</th>
                    <th style="padding: 5px; border: 1px solid #000000;">Total</th>
                  </tr>
                  <tr *ngFor="let item of data.items || []; let index = index" style="border: 1px solid #000000">
                    <td style="text-align: center; border: 1px solid #000000;">{{ index + 1 }}</td>
                    <td style="line-height: 16px; border: 1px solid #000000;">
                      <div style="font-weight: bold; font-size: 14px; color: #08306B;">{{ item.code }}</div>
                      <div style="font-size: 12px;">{{ item.description }}</div>
                    </td>
                    <td
                      style="font-size: 13px; text-align: end; border: 1px solid #000000;">{{ item.unitPrice | number: '1.2-2' }}
                    </td>
                    <td style="text-align: center; border: 1px solid #000000;">{{ item.quantity | number: '1.0-3' }}
                    </td>
                    <td
                      style="font-weight: 500; font-size: 13px; text-align: end; border: 1px solid #000000;">{{ item.total | number: '1.2-2' }}
                    </td>
                  </tr>
                  <tr *ngIf="!(data.items?.length)">
                    <td colspan="5" style="text-align: center; padding: 12px; border: 1px solid #000000;">No items
                      available.
                    </td>
                  </tr>
                </table>
              </ng-container>

              <!-- Add other template types here as needed -->


              <!-- Receive Payment Template (1) -->
              <!-- Debit Note Template (2) -->
              <!-- Credit Note Template (3) -->
              <!-- Bill Template (4) -->
              <!-- Customer Refund Template (5) -->
              <!-- AP Pay Bills Template (6) -->


              @if (previewTemplateKey === templateKeys.receivePayment) {
                <app-transaction-preview-receive-payment [currencyCode]="data.currencyCode" [items]="data.knockoffItems"
                                                         [totalAmount]="data.knockoffTotal"
                                                         [totalPayment]="data.paymentTotal"
                                                         [unmatchedAmount]="data.unmatchedAmount" />
              }

              @if (previewTemplateKey === templateKeys.apPayBills) {
                <app-transaction-preview-pay-bill
                  [currencyCode]="data.currencyCode" [knockoffItems]="data.knockoffItems"
                  [unmatchedAmount]="data.unmatchedAmount"
                  [accountItems]="data.accountItems" [accountTotal]="data.accountTotal"
                  [taxableAmount]="data.taxableAmount"
                  [taxAmount]="data.taxAmount" [netTotal]="data.netTotal" />
              }

              @if (previewTemplateKey === templateKeys.customerRefund) {
                <app-transaction-preview-customer-refund [currencyCode]="data.currencyCode"
                                                         [knockoffItems]="data.knockoffItems"
                                                         [unmatchedAmount]="data.unmatchedAmount"
                                                         [accountItems]="data.accountItems"
                                                         [accountTotal]="data.accountTotal"
                                                         [taxableAmount]="data.taxableAmount"
                                                         [taxAmount]="data.taxAmount" [netTotal]="data.netTotal">
                </app-transaction-preview-customer-refund>
              }

              @if (previewTemplateKey === templateKeys.creditNote) {
                <app-transaction-preview-credit-note
                  [currencyCode]="data.currencyCode" [items]="data.accountItems"
                  [totalAmount]="data.accountTotal"
                  [taxableAmount]="data.taxableAmount" [taxAmount]="data.taxAmount"
                  [netTotal]="data.netTotal">
                </app-transaction-preview-credit-note>
              }

              @if (previewTemplateKey === templateKeys.debitNote) {
                <app-transaction-preview-debit-note
                  [currencyCode]="data.currencyCode" [items]="data.accountItems"
                  [totalAmount]="data.accountTotal"
                  [taxableAmount]="data.taxableAmount" [taxAmount]="data.taxAmount"
                  [netTotal]="data.netTotal">
                </app-transaction-preview-debit-note>
              }

              @if (previewTemplateKey === templateKeys.bill) {
                <app-transaction-preview-bill
                  [currencyCode]="data.currencyCode" [items]="data.accountItems" [totalAmount]="data.accountTotal"
                  [taxableAmount]="data.taxableAmount" [taxAmount]="data.taxAmount" [netTotal]="data.netTotal">
                </app-transaction-preview-bill>
              }


              <!-- Summary for Default Invoice -->
              <div *ngIf="previewTemplateKey === templateKeys.defaultInvoice"
                   style="display: flex; margin-bottom: 10px; padding-left: 20px; padding-right: 35px; line-height: 24px; margin-top: 20px;">
                <div style="margin: 0 0 0 auto;">
                  <table cellpadding="0">
                    <tr>
                      <td style="text-align: right;"><b>TAXABLE AMOUNT</b></td>
                      <td
                        style="text-align: right; font-weight: 500; padding-left: 20px;">{{ data.currencyCode }} {{ data.taxableAmount | number: '1.2-2' }}
                      </td>
                    </tr>
                    <tr>
                      <td style="text-align: right;"><b>TAX</b></td>
                      <td
                        style="text-align: right; font-weight: 500; padding-left: 20px;">{{ data.currencyCode }} {{ data.taxAmount | number: '1.2-2' }}
                      </td>
                    </tr>
                    <tr>
                      <td style="text-align: right;"><b>NET TOTAL</b></td>
                      <td
                        style="text-align: right; font-weight: 500; padding-left: 20px;">{{ data.currencyCode }} {{ data.netTotal | number: '1.2-2' }}
                      </td>
                    </tr>
                  </table>
                </div>
              </div>

              <!-- Total Amount Banner -->
              <div style="background-color: #08306B; margin-bottom: 15px; height: 80px; width: 100%; display: flex;">
                <div style="color: white; font-weight: 600; font-size: 17px; display: flex; margin: auto auto;">
                  <div>TOTAL AMOUNT</div>
                  <div style="margin-left: 15px;">{{ data.currencyCode }} {{ data.totalAmount | number: '1.2-2' }}</div>
                </div>
              </div>

              <!-- Footer Note -->
              <div style="font-size: 12px; line-height: 12px;">
                Please note: If you suspect this document is fraudulent or not intended for you, kindly disregard it or
                consult the business owner before taking any action.
              </div>

              <!-- QNE Logo -->
              <div style="margin-top: 20px; display: flex; width: 100%;">
                <div style="text-align: center; margin: 0 auto;">
                  <img
                    src="https://qnestorage.blob.core.windows.net/cloud-accounting/Email%20Resouces/official-logo-new-colored.png"
                    style="width: auto; height: 25px; margin-bottom: 10px;" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Footer -->
  <ng-template #footer>
    <div nz-row>
      <div nz-col nzSpan="10">
        <div class="hide-in-full">
          <button type="button" nz-button nzType="default" (click)="handleCancel()">Cancel</button>
          <button type="button" nz-button nzType="primary" (click)="handleSubmit()">Send</button>
        </div>
      </div>
      <div nz-col nzSpan="14"></div>
    </div>
  </ng-template>
</nz-modal>
